import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentSection, Layout, Paragraph, SectionHeading } from '@vwfs-bronson/bronson-react';

interface Props {
  formData?: any;
}

export const IdentFailedPage: FunctionComponent<Props> = () => {
  const { t } = useTranslation();

  return (
    <>
      {/* <ContentSection pageWrap>
        <ShoppingCart formData={formData} dataTheme="default" />
      </ContentSection> */}
      <ContentSection pageWrapSize="small">
        <SectionHeading level={3}>{t('identFailedPage:title')}</SectionHeading>
        <Layout center>
          <Layout.Item>
            <Paragraph>{t('identFailedPage:subtitle')}</Paragraph>
          </Layout.Item>
        </Layout>
      </ContentSection>
    </>
  );
};
